import React, { useState } from "react";
import { Link } from "react-router";

import data from "../data.json";

// const albumContent = data.albums.map((album, index) => {
//   return (
//     <Link to={`/${album.date}`} key={index}>
//       <div key={index} className="album">
//         <div className="album-image">
//           <div className="image-container">
//             <img
//               src={`https://i.imgur.com/${album.image[0]}.jpeg`}
//               alt={album.title}
//               loading="lazy"
//             ></img>
//           </div>
//           <span>{album.title}</span>
//         </div>
//         <div className="album-info">
//           <div>{album.date}</div>
//           <div>
//             <span className="dayStyle">{album.day}</span>
//           </div>
//         </div>
//       </div>
//     </Link>
//   );
// });

function Home() {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;

  const albums = [
    ...data.albums.map((album) => ({ ...album, type: album.type || "public" })),
    ...data.secret.map((album) => ({ ...album, type: "secret" })),
  ].sort((first, second) => {
    const firstDate = Date.parse(first.date);
    const secondDate = Date.parse(second.date);
    if (Number.isNaN(firstDate)) return Number.isNaN(secondDate) ? 0 : 1;
    if (Number.isNaN(secondDate)) return -1;
    return secondDate - firstDate;
  });
  const isSecretAuthed = sessionStorage.getItem("secretAuthed") === "true";

  const totalPages = Math.ceil(albums.length / itemsPerPage);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = albums.slice(indexOfFirstItem, indexOfLastItem);

  // 페이지 번호 배열 생성
  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
  return (
    <>
      {/* <div className="Article">{albumContent}</div> */}
      <div className="Article">
        {currentItems.map((item, index) => (
          <Link
            to={item.type === "secret" && !isSecretAuthed ? "/auth" : `/${item.date}`}
            state={item.type === "secret" ? { from: `/${item.date}` } : undefined}
            key={index}
          >
            <div key={index} className="album">
              <div className="album-image">
                {item.type === "secret" && !isSecretAuthed ? (
                  <div className="image-container secret-thumbnail-mask" aria-hidden="true">
                    {"*".repeat(Array.from(item.title).length)}
                  </div>
                ) : (
                  <div className="image-container">
                    <img
                      src={`https://i.imgur.com/${item.image[0]}.jpeg`}
                      alt={item.title}
                      loading="lazy"
                    ></img>
                  </div>
                )}
                <span style={{ fontFamily: "HSBombaram", letterSpacing: 0, wordBreak: "keep-all" }}>
                  {item.type === "secret" && !isSecretAuthed
                    ? "*".repeat(Array.from(item.title).length)
                    : item.title}
                </span>
              </div>
              <div className="album-info">
                <div>{item.date}</div>
                <div>
                  <span className="dayStyle">{item.day}</span>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
      <div className="pagination">
        {pageNumbers.map((number) => (
          <button
            key={number}
            onClick={() => setCurrentPage(number)}
            className={`pagination-button${currentPage === number ? " active" : ""}`}
            aria-current={currentPage === number ? "page" : undefined}
          >
            {number}
          </button>
        ))}
      </div>
    </>
  );
}

export default Home;
